/**
 * © Copyright Union Systems Inc 2026. All rights reserved.
 */

export const ArrowTopRightIcon = (
  props: React.ComponentPropsWithoutRef<'svg'>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.21934 7.78C0.0788894 7.63937 0 7.44875 0 7.25C0 7.05125 0.0788894 6.86063 0.21934 6.72L5.43934 1.5H1.74934C1.55043 1.5 1.35966 1.42098 1.21901 1.28033C1.07836 1.13968 0.99934 0.948912 0.99934 0.75C0.99934 0.551088 1.07836 0.360322 1.21901 0.21967C1.35966 0.0790175 1.55043 0 1.74934 0H7.24934C7.44825 0 7.63902 0.0790175 7.77967 0.21967C7.92032 0.360322 7.99934 0.551088 7.99934 0.75V6.25C7.99934 6.44891 7.92032 6.63968 7.77967 6.78033C7.63902 6.92098 7.44825 7 7.24934 7C7.05043 7 6.85966 6.92098 6.71901 6.78033C6.57836 6.63968 6.49934 6.44891 6.49934 6.25V2.56L1.27934 7.78C1.13871 7.92045 0.948091 7.99934 0.74934 7.99934C0.550589 7.99934 0.359965 7.92045 0.21934 7.78Z"
      fill="currentColor"
    />
  </svg>
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="8"
  //   height="9"
  //   viewBox="0 0 8 9"
  //   fill="currentColor"
  //   {...props}
  // >
  //   <path
  //     fillRule="evenodd"
  //     clipRule="evenodd"
  //     d="M0.21934 8.28024C0.0788894 8.13962 0 7.94899 0 7.75024C0 7.55149 0.0788894 7.36087 0.21934 7.22024L5.43934 2.00024H1.74934C1.55043 2.00024 1.35966 1.92123 1.21901 1.78057C1.07836 1.63992 0.99934 1.44916 0.99934 1.25024C0.99934 1.05133 1.07836 0.860566 1.21901 0.719914C1.35966 0.579262 1.55043 0.500244 1.74934 0.500244H7.24934C7.44825 0.500244 7.63902 0.579262 7.77967 0.719914C7.92032 0.860566 7.99934 1.05133 7.99934 1.25024V6.75024C7.99934 6.94916 7.92032 7.13992 7.77967 7.28057C7.63902 7.42123 7.44825 7.50024 7.24934 7.50024C7.05043 7.50024 6.85966 7.42123 6.71901 7.28057C6.57836 7.13992 6.49934 6.94916 6.49934 6.75024V3.06024L1.27934 8.28024C1.13871 8.42069 0.948091 8.49958 0.74934 8.49958C0.550589 8.49958 0.359965 8.42069 0.21934 8.28024Z"
  //     fill="currentColor"
  //   />
  // </svg>
)
